const apiKey = "Dfqjq6LGs95DWLYeOCcbfuq4BADGIb0Y"

export default apiKey